var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "meta-8",
  "use": "meta-8-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"meta-8\"><path d=\"M15.8 24.519v-1.843H5.723c-.4 0-.72-.328-.72-.737V6.743c0-.41.32-.737.72-.737h21.553c.4 0 .72.328.72.737v15.196c0 .451-.32.737-.68.737H17.239v1.843h4.079c.4 0 .72.328.72.737 0 .41-.36.737-.72.737h-9.597c-.4 0-.72-.328-.72-.737 0-.41.32-.737.72-.737H15.8zm-9.357-3.236h20.153V7.52H6.443v13.763zm17.754-1.352h-2.279c-.4 0-.72-.328-.72-.737 0-.41.32-.737.72-.737h2.279c.4 0 .72.328.72.737 0 .41-.36.737-.72.737z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol